import { render, staticRenderFns } from "./menu-left.vue?vue&type=template&id=2c2fd923&scoped=true&"
import script from "./menu-left.vue?vue&type=script&lang=js&"
export * from "./menu-left.vue?vue&type=script&lang=js&"
import style0 from "./menu-left.vue?vue&type=style&index=0&id=2c2fd923&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2fd923",
  null
  
)

export default component.exports